import React from 'react';
import { PopularLinksBoxProps } from './props';
import styles from './style.module.scss';

const PopularLinksBox: React.FC<PopularLinksBoxProps> = ({
  title,
  headingLevel: Heading = 'h2',
  links,
}) => {
  const MAX_PER_COLUMN = 8;
  const columns = [];
  for (let i = 0; i < links.length; i += MAX_PER_COLUMN) {
    columns.push(links.slice(i, i + MAX_PER_COLUMN));
  }

  return (
    <div className={styles['popular-links-box']}>
      <Heading className={styles['popular-links-box__title']}>{title}</Heading>
      <div className={styles['popular-links-box__columns']}>
        {columns.map((column, colIndex) => (
          <ul key={colIndex} className={styles['popular-links-box__list']}>
            {column.map((link, linkIndex) => (
              <li key={linkIndex} className={styles['popular-links-box__item']}>
                <a href={link.url} className={styles['popular-links-box__link']}>
                  {link.label}
                </a>
              </li>
            ))}
          </ul>
        ))}
      </div>
    </div>
  );
};

export default PopularLinksBox;
